<template>
  <div class="profile-view">
    <FloatingHeader
      title="Meu Perfil"
      sbtitle=""
      :showHeader="true"
      :hideSearch="true"
      :toClear="'updateCurrentItemEdit'"
      :routeToBack="''"
    ></FloatingHeader>

    <!-- <div class="profile-image">
      <img :src="imagePreviewUrl || userImgMock" alt="Profile" v-if="userImgMock || imagePreviewUrl" />
      <fa v-else icon="user" class="fa" />
      <div class="image-options">
        <div class="edit-image" @click="openChangeImageModal">
          <h2>Editar Imagem</h2>
          <fa icon="pen-to-square" />
        </div>
        <div class="remove-image" @click="openRemoveImgModal">
          <h2>Remover</h2>
          <fa icon="trash-alt" />
        </div>
      </div>
    </div> -->

    <div class="profile-sections">
      <div class="normal-sections">
        <div class="section" v-for="(section, key) in profileSections" :key="key" @click="() => handleSectionClick(section)">
          <div class="icon-title">
            <div class="section-icon">
              <img v-if="section.customIcon" :src="section.icon" >
              <fa v-else :icon="section.icon" />
            </div>
            <div class="section-title">
              <h2 v-text="section.title" />
            </div>
          </div>

          <div class="section-arrow">
            <fa icon="chevron-right" />
          </div>
        </div>
      </div>

      <div class="logout-section">
        <div class="section" @click="confirmLogout">
          <div class="icon-title
          ">
            <div class="section-icon">
              <fa icon="sign-out-alt" />
            </div>
            <div class="section-title">
              <h2>Sair</h2>
            </div>
          </div>
        </div>
      </div>
    </div>

    <CustomModal :modalOpen="changeImageModalOpen" @closeModal="changeImageModalOpen = false">
      <div class="change-image-modal">
        <div class="image-input">
          <label for="inputfile" class="add-image-label" v-if="!imagePreviewUrl">
            Adicionar imagem
          </label>
          <input type="file" id="inputfile" @change="handleFileUpload" class="file-input" ref="inputfile">
          <div class="image-preview" v-if="imagePreviewUrl" @click="triggerFileInput">
            <img :src="imagePreviewUrl" alt="Preview da imagem">
            <h2>Escolher outra imagem</h2>
          </div>
        </div>

        <div class="b-button">
          <button class="btn btn-confirm" @click="updateImage">Salvar</button>
        </div>
      </div>
    </CustomModal>

    <ModalInfo :modalOpen="removeImgModalOpen" @actionTrue="confirmRemoveImg" @actionFalse="removeImgModalOpen = false">
    </ModalInfo>

    <ModalInfo :modalOpen="confirmLogoutModalOpen" @actionTrue="logOut" @actionFalse="confirmLogoutModalOpen = false"> </ModalInfo>
  </div>
</template>

<script>
import FloatingHeader from '@/components/FloatingHeader.vue'
import { mapGetters, mapActions } from 'vuex'
import { doLogout } from '@/assets/controllers/LoginController'
import ModalInfo from '@/components/modals/ModalInfo.vue'
import Util from '@/assets/libs/util'
import CustomModal from '@/components/modals/CustomModal.vue'

export default {
  name: 'ProfileView',
  components: {
    FloatingHeader,
    ModalInfo,
    CustomModal
  },
  data () {
    return {
      // userImgMock: require('@/assets/img/profile-default.png'),
      imagePreviewUrl: null,
      imgFile: null,
      imgBase64: null,
      changeImageModalOpen: false,
      profileSections: [
        {
          title: 'Dados Pessoais',
          icon: 'user',
          route: 'profile-data'
        },
        {
          title: 'Alterar Senha',
          icon: 'key',
          route: 'update-password'
        },
        {
          title: 'Pedidos',
          icon: 'shopping-cart',
          route: 'orders'
        },
        {
          title: 'Cartões',
          icon: 'credit-card',
          route: 'my-cards'
        },
        {
          title: 'Ajuda',
          customIcon: true,
          icon: require('@/assets/icons/wpp.png'),
          action: 'callWppHelp'
        }
      ],
      removeImgModalOpen: false,
      confirmLogoutModalOpen: false
    }
  },
  methods: {
    ...mapActions(['showModalInfo']),
    openChangeImageModal () {
      this.changeImageModalOpen = true
    },
    handleFileUpload (event) {
      const file = event.target.files[0]

      // Verificar se o arquivo é uma imagem válida (JPG ou PNG)
      if (file && (file.type === 'image/jpeg' || file.type === 'image/png')) {
        this.imgFile = file
        this.imagePreviewUrl = URL.createObjectURL(file)

        // gets the base64 string of the image and console.log it
        const reader = new FileReader()
        reader.onload = (e) => {
          this.imgBase64 = e?.target?.result
        }
        reader.readAsDataURL(file)
      } else {
        alert('Por favor, selecione uma imagem no formato JPG ou PNG.')
      }
    },
    triggerFileInput () {
      this.$refs.inputfile.click()
    },
    updateImage () {
      if (!this.imgFile) {
        // alert('Nenhuma imagem selecionada.')
        Util.showWarningNotification({
          title: 'Atenção',
          text: 'Nenhuma imagem selecionada.'
        })
        return
      }

      // Lógica para salvar a imagem (pode envolver chamada de API ou lógica local)
      console.log('Imagem salva:', this.imgFile)
      console.log('Base64:', this.imgBase64)
      this.userImgMock = this.imagePreviewUrl
      this.imagePreviewUrl = null
      this.imgFile = null
      this.changeImageModalOpen = false
    },
    handleSectionClick (section) {
      if (section.action) {
        this[section.action]()
      } else {
        this.$router.push(section.route)
      }
    },
    logOut: function () {
      doLogout()
      this.$router.push('/login')
    },
    confirmLogout: function () {
      this.confirmLogoutModalOpen = true
      this.showModalInfo({
        type: 'defaultDialog',
        text: 'Deseja realmente sair?',
        icon: 'fa-solid fa-sign-out-alt'
      })
    },
    callWppHelp: function () {
      return Util.callWppHelp()
    },
    openRemoveImgModal: function () {
      this.removeImgModalOpen = true
      this.showModalInfo({
        type: 'defaultDialog',
        text: 'Confirma a remoção da imagem?',
        icon: 'fa-solid fa-trash'
      })
    },
    confirmRemoveImg: function () {
      // todo: remove image
      this.userImgMock = null
      this.removeImgModalOpen = false
    }
  },
  computed: {
    ...mapGetters(['getUser'])
  },
  mounted () {
    if (!this.getUser) {
      // this.$router.push('login')
    }
  }
}
</script>

<style lang="less">
.profile-view {
  position: relative;
  display: block;
  padding: 65px 20px 173px 20px;
  height: calc(var(--real-vh) - 268px);

  .profile-image {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;

    img {
      width: 150px;
      height: 150px;
      border-radius: 50%;
      object-fit: cover;
    }

    .fa {
      font-size: 100px;
      width: 150px;
      height: 150px;
      color: #ccc;
    }

    .image-options {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      margin-top: 10px;
      width: 100%;

      .edit-image,
      .remove-image {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 10px;
        border-bottom: 1px solid #ccc;
        color: #666;

        h2 {
          font-size: 14px;
          margin-bottom: 5px;
        }
      }
    }
  }

  .change-image-modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;

    .image-input {
      .file-input {
        display: none;
      }

      .add-image-label {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 150px;
        height: 150px;
        border: 2px dashed #828282;
        border-radius: 5px;
        cursor: pointer;
        color: #828282;
        font-size: 16px;
        font-weight: bold;
        text-align: center;
      }

      .image-preview {
        width: 180px;
        height: 170px;
        border-radius: 5px;
        padding: 5px;
        font-size: 14px;
        font-weight: 500;
        color: #232323;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        img {
          width: 100%;
          height: 100%;
          max-width: 150px;
          max-height: 130px;
          object-fit: contain;
          cursor: pointer;
        }

        h2 {
          font-size: 12px;
          font-weight: 500;
          cursor: pointer;
        }
      }
    }

    .b-button {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;

      .btn-confirm {
        width: 80px;
        height: 30px;
        border-radius: 5px;
        border: none;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        background-color: var(--primaryColor);
        color: white;
      }
    }
  }

  .profile-sections {
    // margin: 20px 0 25px 0;
    overflow: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .section {
      display: flex;
      align-items: center;
      padding: 10px 0;

      .icon-title {
        display: flex;
        align-items: center;
        flex: 1;

        .section-icon {
          position: relative;
          margin-right: 10px;
          color: var(--primaryColor);
          border-radius: 10px;
          height: 16px;
          width: 16px;
          padding: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          &:before {
            z-index: -1;
            opacity: .2;
            background: var(--primaryColor);
            position: absolute;
            content: '';
            bottom: 0;
            right: 0;
            left: 0;
            top: 0;
          }
          img {
            max-width: 100%;
          }
        }

        .section-title {
          h2 {
            font-size: 16px;
          }
        }
      }
    }

    .logout-section {
      // margin-bottom: 20px;
      position: absolute;
      bottom: 20px;
      width: -webkit-fill-available;
      right: 20px;
      left: 20px;

      .section {
        border-top: 1px solid #ccc;
      }
    }
  }
}
</style>
